import React, { Component } from "react";
import { LabelString, LabelDollarFormatted, LabelPercentFormatted, HEDGE_TYPES } from "@loanbossinc/component-library";

export class StyledRateOrStrike extends Component {
    displayHedgeData = (value) => {
        if (!value) return (<LabelString value={""} />);
        return value.reduce((acc, cur, index) => {
            if (!cur) return acc;
            if (index > 0) acc.push(<span style={{ paddingLeft: "5px", paddingRight: "5px" }}>/</span>);
            acc.push(
                <div style={{ display: "flex" }} key={index}>
                    <LabelPercentFormatted value={cur.value} decimals={2} />
                    <LabelString value={cur.abbrev} style={{ paddingLeft: "5px", fontWeight: "500" }} />
                </div>)
            return acc;
        }, []);
    }
    render() {
        const { value } = this.props;
        return (
            <div style={{ display: "flex" }}>
                {this.displayHedgeData(value)}
            </div>
        )
    }
}

export class StyledCost extends Component {
    render() {
        const { value } = this.props;
        return (
            <div style={{ textAlign: "center" }}>
                {value !== null ?
                    <div>
                        {value.hedgeType === HEDGE_TYPES.CAP ?
                            <LabelDollarFormatted value={value.cost} decimals={0} />
                            : <LabelPercentFormatted value={value.cost} decimals={2} />
                        }
                    </div>
                    : <LabelString value={value} />}
            </div>
        )
    }
}